import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const QUOTES = [
  {
    q: "Bairbre made me feel understood from the very first session. Nothing was rushed, nothing was judged.",
    a: "Individual therapy client",
  },
  {
    q: "For the first time we felt we truly understood our son — and had real tools to support him.",
    a: "Parent of a neurodivergent child",
  },
  {
    q: "The assessment gave us the clarity we'd been searching for, explained with such warmth.",
    a: "Assessment client",
  },
];

export const Testimonials = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x = useTransform(scrollYProgress, [0, 1], ["4%", "-4%"]);

  return (
    <section
      data-testid="testimonials-section"
      ref={ref}
      className="relative mx-auto max-w-7xl px-6 lg:px-10 py-28 lg:py-36"
    >
      <motion.p
        style={{ x }}
        className="font-serif italic font-light text-primary text-3xl sm:text-5xl lg:text-6xl leading-tight max-w-4xl"
      >
        “Seen clearly, we all have room to grow.”
      </motion.p>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-10">
        {QUOTES.map((t, i) => (
          <motion.blockquote
            key={i}
            data-testid={`testimonial-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="border-t border-border pt-6"
          >
            <span className="h-2 w-8 rounded-full prism-line block mb-5" />
            <p className="font-serif text-xl font-light leading-relaxed text-primary">
              {t.q}
            </p>
            <footer className="mt-5 text-xs uppercase tracking-[0.18em]" style={{ color: "hsl(var(--muted-foreground))" }}>
              {t.a}
            </footer>
          </motion.blockquote>
        ))}
      </div>
    </section>
  );
};
